exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .row-no-data {\n  text-align: center;\n}\n\n.membership-benefit-mini-table tr td:first-child {\n  padding-right: 5px;\n}\n.membership-benefit-mini-table tr td:not(:first-child) {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.membership-benefit-mini-table .clickable {\n  color: #3097d1;\n  cursor: pointer;\n}", ""]);

// exports
